import { IImage } from "../../../Models/PhotoGallery/IImage";
import { IImageThumbnail } from "../../../Models/PhotoGallery/IImageThumbnail";
import { IResult } from "../../../Models/Result/IResult";
import { formatUrl, handleError } from "../ApiHelpers";
import { IPhotoGalleryApi } from "./IPhotoGalleryApi";
import axios from 'axios';
import { IFolder } from "../../../Models/PhotoGallery/IFolder";
export class PhotoGalleryApi implements IPhotoGalleryApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getFolders(id?: number): Promise<IResult<IFolder>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/GeImageFolders?id=${id ? id:""}`);
            const response = await axios.get(url);
            const res = response.data as IResult<IFolder>;
            return res;
        }
        catch (error) {
            return handleError(error, "getFolders");
        }
    }

    async createFolder(name: string, parentId?: number): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/CreateFolders`);

            const response = await axios.post(url, {
                name: name,
                parentId:parentId ? parentId:null
            });
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createFolder");
        }
    }

    async deleteFolder(id: number): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/DeleteFolders/id=${id}`);
            const response = await axios.delete(url);
            const res = response.data as IResult<boolean>;
            return res;
        }
        catch (error) {
            return handleError(error, "getFolders");
        }
    }

    async getImageThumbnails(folder: number): Promise<IResult<IImageThumbnail[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/GetAllImagesThumbnail/` + folder);
            const response = await axios.get(url);
            const res = response.data as IResult<IImageThumbnail[]>;
            return response.data as IResult<IImageThumbnail[]>;
        }
        catch (error) {
            return handleError(error, "getImageThumbnails");
        }
    }

    async getImageById(id: number): Promise<IResult<IImage>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/GeImageById?id=` + id.toString());
            const response = await axios.get(url);
            return response.data as IResult<IImage>;
        }
        catch (error) {
            return handleError(error, "getImageById");
        }
    }

    async addImage(folderId: number, file: File, description?: string, callback?: (progress: number, fileName: string) => void): Promise<IResult<number>> {
            var data = new FormData();
            data.append('file', file);
            description && data.append('description', description);
            data.append('folderId', folderId.toString()); 
        
            var config = {
                onUploadProgress: function (progess: any) {
                    var percentCompleted = Math.round((progess.loaded * 100) / progess.total);
                    callback && callback(percentCompleted, file.name);
                }
            };
        try {
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/AddImage`);
                const response = await axios.post(url, data, config);
                return response.data as IResult<number>;
            }
        catch(error) {
                return handleError(error, "addImage");
            }
    }    

    async deleteImages(ids: number[]): Promise<IResult<boolean>> {
        try {
            const idsPairs = ids.map(x => `ids=${x}`);
            const url = formatUrl(this.backendUrl, `/api/PhotoGallery/DeleteImages?` + idsPairs.join('&'));
            const response = await axios.delete(url);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "getImageById");
        }
    }

    async editImageDescription(id: number, description: string): Promise<IResult<boolean>> {
        throw new Error("Method not implemented.");
    }


}